import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { path } from 'ramda'

import {
  POST_CAFETERIA_CUSTOMER_SETTINGS_LIMIT,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cafeteria/customer/settings/limit/post'

import { api } from 'app/api'
import type { LimitsType, Params } from 'app/common/components/Cafeteria/dataTypes/customer/settings/limit'
import useCallbackRef from 'app/common/hooks/useCallbackRef'


const greateParamsFromPartial = (params: Partial<Params>, customerID?: string) => {
  const maybeParams = { ...params, customerID }

  if ('customerID' in maybeParams) {
    if ('personalLimit' in maybeParams || 'sellPointsPersonalLimits' in maybeParams) {
      return maybeParams as Params
    }
  }
  return null
}

type Oprions = {
  onSuccess?: (limits: LimitsType) => void
  onErrorExceed?: (maxLimit: number) => void
  params: Pick<Params, 'customerID'>
}

export function useCustomerLimitSubmit({ onSuccess, onErrorExceed, params: { customerID } }: Oprions) {
  const { t } = useTranslation('cafeteria')

  const onSuccessRef = useCallbackRef(onSuccess)
  const onErrorExceedRef = useCallbackRef(onErrorExceed)

  const submit = useCallback(async (maybeParams: Partial<Params>) => {
    const params = greateParamsFromPartial(maybeParams, customerID)
    if (!params) {
      console.error('Неверно переданы параметры в useCustomerLimitSubmit')
      return null
    }
    const res = await api.request(POST_CAFETERIA_CUSTOMER_SETTINGS_LIMIT, {
      error: (error: Error) => {
        const code = path(['response', 'data', 'error_code'], error)
        const exceed = path(['response', 'data', 'max_limit'], error)
        if (code === 1 && typeof exceed === 'number') {
          onErrorExceedRef.current?.(exceed)
        }
        return t('settings_limit_set_error', 'Не удалось установить лимит')
      },
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })
    if (res) {
      onSuccessRef.current?.(res)
    }
    return res
  }, [customerID, t, onSuccessRef, onErrorExceedRef])

  return {
    submit,
  }
}
